export default __webpack_public_path__ + "static/media/signal-solid.a4ed0977.svg";